import { List, ThemeIcon } from "@mantine/core";
import { IconCheck, IconX } from "@tabler/icons-react";
import { validatePassword } from "../../utils/passwordValidation";

interface PasswordStrengthIndicatorProps {
  password: string;
}

export default function PasswordStrengthIndicator({
  password,
}: PasswordStrengthIndicatorProps) {
  const { rules } = validatePassword(password);

  if (!password) return null;

  return (
    <List spacing="xs" size="sm" center>
      {rules.map((rule) => (
        <List.Item
          key={rule.label}
          icon={
            <ThemeIcon
              color={rule.met ? "green" : "red"}
              size={20}
              radius="xl"
              variant="light"
            >
              {rule.met ? <IconCheck size={12} /> : <IconX size={12} />}
            </ThemeIcon>
          }
        >
          {rule.label}
        </List.Item>
      ))}
    </List>
  );
}
